<template>
  <CBox d="flex" flexDirection="column">
    <OmtRow mb="24px">
      <CFlex direction="column">
        <OmtTypography as="h1-bold" color="var(--colors-light-primary-navy-blue)"> Credenciados </OmtTypography>
      </CFlex>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="h2-bold" color="#4A5E77"> {{ getEstablishmentDescription }} </OmtTypography>
    </OmtRow>
    <OmtRow>
      <CBox w="100%" display="flex" alignItems="center" mb="24px" pb="4px" pt="2" grid-column-gap="8px">
        <CBox position="relative" flex-shrink="0">
          <OmtButton
            size="sm"
            :variant="hasFilters ? 'solid' : 'outline'"
            rightIcon="sliders-h"
            iconMarginRight="0"
            borderRadius="0px"
            :iconColor="hasFilters ? 'white' : '#4A5E77'"
            iconSize="sm"
            border=".5px solid var(--colors-light-secondary-divider)"
            @click="showFilterModal = true"
            w="auto !important"
            px="16px"
            :bg="hasFilters ? 'var(--colors-light-primary-navy-blue)' : 'white'"
          >
            <OmtTypography as="button-small" :color="hasFilters ? 'white' : '#4A5E77'"> Filtrar </OmtTypography>
          </OmtButton>
          <CBox
            v-show="filtersCount"
            position="absolute"
            top="-8px"
            right="0"
            bg="white"
            border="1px solid var(--colors-light-primary-navy-blue)"
            border-radius="12px"
            min-h="16px"
            min-w="16px"
            h="16px"
            w="16px"
            display="flex"
            justify-content="center"
            align-items="center"
            z-index="1"
          >
            <OmtTypography as="p2" color="var(--colors-light-primary-navy-blue)" font-weight="bold">
              {{ filtersCount }}
            </OmtTypography>
          </CBox>
        </CBox>
        <OmtButton
          leftIcon="arrow-up-arrow-down"
          size="sm"
          iconSize="sm"
          borderRadius="0px"
          border=".5px solid var(--colors-light-secondary-divider)"
          :variant="!!sort ? 'solid' : 'outline'"
          :iconColor="!!sort ? 'white' : '#4A5E77'"
          w="115px !important"
          @click="showSortModal = true"
        >
          <OmtTypography as="button-small" :color="!!sort ? 'white' : '#4A5E77'"> Ordenar </OmtTypography>
        </OmtButton>
        <OmtButton
          variant="ghost"
          :disabled="!filtersCount && !sort"
          size="sm"
          w="105px !important"
          ml="auto"
          @click="cleanSortsAndFilters"
        >
          Limpar
        </OmtButton>
      </CBox>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="h2-bold" color="#4A5E77"> Localize por nome </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtInput
        variant="filled"
        placeholder="Digite o nome do profissional ou clínica"
        icon-right="search"
        v-model="textSearch"
      />
    </OmtRow>
    <OmtRow v-for="(item, index) in list" :key="index">
      <DoctorsListItem
        @click="onClick(item)"
        :TipoLogradouro="item.TipoLogradouro"
        :EnderecoRua="item.EnderecoRua"
        :EnderecoNumero="item.EnderecoNumero"
        :EnderecoBairro="item.EnderecoBairro"
        :CodigoEstado="item.CodigoEstado"
        :EnderecoCidade="item.EnderecoCidade"
        :DescricaoPrestador="item.DescricaoPrestador"
        :DescricaoEspecialidade="item.DescricaoEspecialidade"
        :Distancia="item.Distancia"
        :Network="item.NetworkName"
        :Favorito="item.Favorito"
        :CodigoPrestador="item.CodigoPrestador"
        :SrEndereco="item.SrEndereco"
        :DsIdioma="item.DsIdioma"
        :Nota="item.ScoreTotal"
        :WhatsApp="item.WhatsApp"
        :Teleconsulta="item.Teleconsulta"
        :Agendamento="item.Agendamento"
        :colorSecondary="true"
      />
    </OmtRow>

    <OmtRow v-if="list.length === 0">
      <OmtTypography as="p1" color="#4A5E77">Nenhum resultado encontrado</OmtTypography>
    </OmtRow>

    <FilterModal
      v-if="showFilterModal"
      @close="showFilterModal = false"
      @save="onFilterSave"
      :filters="filters"
      :facilities="facilities"
      :languages="languages"
      :networks="networks"
      :subspecialties="subspecialties"
    />
    <SortModal v-if="showSortModal" @close="showSortModal = false" @save="onSortSave" :sort="sort" />
  </CBox>
</template>

<script>
import DoctorsListItem from "@/components/Organisms/AffiliateSearch/DoctorsListItem.vue";
import FilterModal from "@/components/Organisms/AffiliateSearch/FilterModal.vue";
import SortModal from "@/components/Organisms/AffiliateSearch/SortModal.vue";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import _ from "lodash";

export default {
  name: "AccreditedList",
  components: { DoctorsListItem, FilterModal, SortModal },
  data() {
    return {
      textSearch: "",
      originalList: [],
      list: [],
      showFilterModal: false,
      showSortModal: false,
      facilities: [],
      languages: [],
      networks: [],
      subspecialties: []
    };
  },
  computed: {
    ...mapState("openNetworkSearch", ["selectedFilters", "selectedSort"]),
    ...mapGetters("openNetworkSearch", ["getPrestadores", "getEstablishmentDescription"]),
    filters() {
      return this.selectedFilters;
    },
    sort() {
      return this.selectedSort;
    },
    hasFilters() {
      return this.filtersCount > 0;
    },
    filtersCount() {
      const activeFacilities = this.filters?.facilities?.filter(fac => !!fac.isActive) || [];
      const activeLanguages = this.filters?.languages?.filter(lang => !!lang.isActive) || [];
      const activeNetworks = this.filters?.networks?.filter(net => !!net.isActive) || [];
      const activeSubspecilties = this.filters?.subspecialties?.filter(esp => !!esp.isActive) || [];

      return activeFacilities.length + activeLanguages.length + activeNetworks.length + activeSubspecilties.length;
    },
    hasSubspecialties() {
      return Array.isArray(this.subspecialties) && this.subspecialties.length > 0;
    }
  },
  watch: {
    textSearch: {
      handler: _.debounce(function () {
        this.filterList();
      }, 500)
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["buscarPorRegiaoAnonimo", "setSelectedProvider"]),
    ...mapMutations("openNetworkSearch", ["SET_FILTERS", "SET_SORT", "SET_DOCTOR_DETAIL"]),
    normalize(value) {
      return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    async loadPrestadores() {
      try {
        this.$root.$emit("show-loading");
        const prestadores = await this.buscarPorRegiaoAnonimo();

        if (prestadores && prestadores.length > 0) {
          this.originalList = prestadores.map(item => ({
            NetworkName: this.getNetworkName(item.TpRede),
            ...item
          }));
          this.getFacilities();
          this.getLanguages();
          this.getNetworkList();
          this.getSubspecialtyList();
          this.filterList();
          this.onSortSave("");
        }
      } catch (error) {
        console.error("Erro ao carregar prestadores:", error);
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    getNetworkName(tpRede) {
      switch (tpRede) {
        case "P":
          return "Principal";
        case "C":
          return "Complementar";
        case "A":
          return "MediService";
        default:
          return "";
      }
    },
    filterList() {
      if (!this.originalList?.length) {
        this.list = [];
        return;
      }

      const interruptFilter = () => {
        if (!list?.length) {
          this.list = [];
          return true;
        }
      };

      let list = [];
      const filteredLanguages = this.filters?.languages?.filter(lang => lang.isActive);
      const filteredSubspecialties = this.filters?.subspecialties?.filter(esp => esp.isActive);
      const filteredNetworks = this.filters?.networks?.filter(net => net.isActive);

      if (filteredLanguages?.length && !this.originalList[0].languages) {
        this.originalList.forEach(
          i => (i.languages = (i.DsIdioma ? i.DsIdioma.split(",") : []).map(l => this.normalize(l).trim()))
        );
      }

      if (this.textSearch === "") {
        list = this.originalList;
      } else {
        if (!this.originalList[0].matchText) {
          this.originalList.forEach(i => (i.matchText = this.normalize(JSON.stringify(i)).toUpperCase()));
        }
        const textSearch = this.normalize(this.textSearch.toUpperCase());
        list = this.originalList.filter(i => i.matchText.indexOf(textSearch) !== -1);
        if (interruptFilter()) return;
      }

      if (filteredLanguages?.length) {
        const languages = filteredLanguages.map(lang => lang.normalizedLabel);
        list = list.filter(i => i.languages.find(langItem => languages.find(langFilter => langFilter === langItem)));
        if (interruptFilter()) return;
      }

      if (filteredSubspecialties?.length) {
        const specialties = filteredSubspecialties.map(esp => esp.normalizedLabel);
        list = list.filter(i => i.subspecialties.find(item => specialties.find(filter => filter === item)));
        if (interruptFilter()) return;
      }

      if (filteredNetworks?.length) {
        const networks = filteredNetworks.map(net => net.normalizedLabel);
        list = list.filter(i => networks.find(filter => filter === i.NetworkName));
        if (interruptFilter()) return;
      }

      if (this.filters?.minimumRate) {
        const minimumRate = Number(this.filters.minimumRate);
        list = list.filter(i => i.ScoreTotal >= minimumRate);
        if (interruptFilter()) return;
      }

      if (this.filters?.facilities?.length) {
        if (this.filters.facilities.find(f => f.name === "online")?.isActive) {
          list = list.filter(i => !!i.Agendamento);
          if (interruptFilter()) return;
        }
        if (this.filters.facilities.find(f => f.name === "videoCall")?.isActive) {
          list = list.filter(i => !!i.Teleconsulta);
          if (interruptFilter()) return;
        }
        if (this.filters.facilities.find(f => f.name === "whatsapp")?.isActive) {
          list = list.filter(i => !!i.WhatsApp);
          if (interruptFilter()) return;
        }
      }

      this.list = list;
    },
    onClick(item) {
      this.setSelectedProvider(item);
      this.$router.push({ name: "network.doctor.detail", params: { CodigoPrestador: item.CodigoPrestador } });
    },
    onFilterSave(filters) {
      this.SET_FILTERS(filters);
      this.filterList();
    },
    onSortSave(sort) {
      this.SET_SORT(sort);

      if (sort === "" || sort === "Indicação Omint") {
        this.list = this.list.sort((a, b) => {
          let base = 0;
          if (a.ScoreTotal < b.ScoreTotal) base = 100;
          if (a.ScoreTotal > b.ScoreTotal) base = -100;
          if (a.Distancia === undefined && b.Distancia === undefined) return base + 3;
          if (a.Distancia === undefined && b.Distancia !== undefined) return base + 2;
          if (a.Distancia !== undefined && b.Distancia === undefined) return base - 2;
          if (a.Distancia < b.Distancia) return base - 1;
          if (a.Distancia > b.Distancia) return base + 1;
          return base;
        });
      } else {
        this.list = this.list.sort((a, b) => {
          if (a.Distancia === undefined && b.Distancia === undefined) return 3;
          if (a.Distancia === undefined && b.Distancia !== undefined) return 2;
          if (a.Distancia !== undefined && b.Distancia === undefined) return -2;
          if (a.Distancia < b.Distancia) return -1;
          if (a.Distancia > b.Distancia) return 1;
          return 0;
        });
      }

      if (sort === "Rede e Distância") {
        const listPrincipal = this.list.filter(s => s.TpRede === "P" || s.TpRede === null);
        const listComplementar = this.list.filter(s => s.TpRede === "C");
        const listMediService = this.list.filter(s => s.TpRede === "A");
        this.list = [...listPrincipal, ...listComplementar, ...listMediService];
      }
    },
    cleanSortsAndFilters() {
      this.onFilterSave({});
      this.onSortSave("");
      this.filterList();
    },
    getFacilities() {
      const facilities = [];
      if (this.originalList.find(i => !!i.Agendamento)) facilities.push({ name: "online" });
      if (this.originalList.find(i => !!i.Teleconsulta)) facilities.push({ name: "videoCall" });
      if (this.originalList.find(i => !!i.WhatsApp)) facilities.push({ name: "whatsapp" });
      this.facilities = facilities;
    },
    getLanguages() {
      const languages = [];
      this.originalList.forEach(item => {
        const langs = item.DsIdioma ? item.DsIdioma.split(",") : ["Português"];
        item.languages = langs.map(lang => {
          const normalizeLabel = this.normalize(lang).trim();
          if (!languages.find(l => l.normalizedLabel === normalizeLabel)) {
            languages.push({
              label: lang,
              normalizedLabel: normalizeLabel
            });
          }
          return normalizeLabel;
        });
      });

      languages.sort(function (a, b) {
        if (a.normalizedLabel > b.normalizedLabel) {
          return 1;
        }
        if (a.normalizedLabel < b.normalizedLabel) {
          return -1;
        }
        return 0;
      });

      this.languages = languages;
    },
    getNetworkList() {
      const networks = [];
      this.originalList.forEach(item => {
        const normalizeLabel = this.normalize(item.NetworkName).trim();
        if (!networks.find(e => e.normalizedLabel === normalizeLabel)) {
          networks.push({
            label: item.NetworkName,
            normalizedLabel: normalizeLabel
          });
        }
      });

      networks.sort((a, b) => {
        if (a.normalizedLabel > b.normalizedLabel) {
          return 1;
        }
        if (a.normalizedLabel < b.normalizedLabel) {
          return -1;
        }
        return 0;
      });

      this.networks = networks;
    },
    getSubspecialtyList() {
      const subspecialties = [];
      this.originalList.forEach(item => {
        const esp = item.SubEspecialidades ? item.SubEspecialidades : [];
        item.subspecialties = esp.map(esp => {
          const normalizeLabel = this.normalize(esp).trim();
          if (!subspecialties.find(e => e.normalizedLabel === normalizeLabel)) {
            subspecialties.push({
              label: esp,
              normalizedLabel: normalizeLabel
            });
          }
          return normalizeLabel;
        });
      });

      subspecialties.sort((a, b) => {
        if (a.normalizedLabel > b.normalizedLabel) {
          return 1;
        }
        if (a.normalizedLabel < b.normalizedLabel) {
          return -1;
        }
        return 0;
      });

      this.subspecialties = subspecialties;
    }
  },
  async mounted() {
    await this.loadPrestadores();
  }
};
</script>
